<template>
    <div class="app-container">
        <div class="filter-container">
            <el-input class="filter-item" style="width:200px;" v-model="listQuery.name" placeholder="用户名" clearable />
            <el-select class="filter-item" v-model="listQuery.state" placeholder="状态" clearable>
                <el-option label="待审核" :value="0" />
                <el-option label="通过" :value="1" />
                <el-option label="失败" :value="2" />
                <el-option label="已打款" :value="3" />
            </el-select>
            <el-button type="primary" icon="el-icon-search" :loading="tableLoading" @click="handleSearch">搜索</el-button>
            <el-button type="warning" icon="el-icon-upload2" :loading="tableLoading"
                @click="exportExcel">导出Excel</el-button>
        </div>
        <div class="table">
            <el-table v-loading="tableLoading" :data="tableData" element-loading-text="Loading" border fit
                highlight-current-row>
                <el-table-column type="index" label="序号" width="85" align="center" />
                <el-table-column prop="user_info.name" label="用户昵称" max-width="180" align="center" />
                <el-table-column prop="expend_integral" label="兑换积分" max-width="180" align="center" />
                <el-table-column prop="withdrawal_price" label="兑换金额" max-width="110" align="center" />
                <el-table-column label="提现币种" width="110" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.currency_type === 1">
                            人民币
                        </el-tag>
                        <el-tag v-else-if="scope.row.currency_type === 2">
                            日元
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="收款类型" width="110" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.collection_type === 1">
                            银行卡
                        </el-tag>
                        <el-tag v-else-if="scope.row.collection_type === 2">
                            支付宝
                        </el-tag>
                        <el-tag v-else-if="scope.row.collection_type === 3">
                            Paypay
                        </el-tag>
                        <el-tag v-else>
                            其它
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="提交时间" width="200" align="center" />
                <el-table-column prop="state" label="状态" width="95" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.state === 0">待审核</el-tag>
                        <el-tag v-else-if="scope.row.state === 1" type="success">通过</el-tag>
                        <el-tag v-else-if="scope.row.state === 2" type="danger">失败</el-tag>
                        <el-tag v-else-if="scope.row.state === 3" type="success">已打款</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="128px" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="checkRequest(scope.row)">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-container">
                <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                    :total="total" background layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>

        <TableActiveModal :show.sync="modalVisible" :detailData="selectedData" @onUpdate="onTableActionModalSubmit" />
    </div>
</template>

<script>
import TableActiveModal from "./components/TableActiveModal.vue"
import { payoutRequests } from "@/api/payoutManagement"
import * as XLSX from "xlsx"

export default {
    data: () => ({
        tableData: [],
        tableLoading: false,
        total: null,
        listQuery: {
            page: 1,
            limit: 10,
            name: "",
            state: null
        },
        modalVisible: false,
        selectedData: ''
    }),
    components: {
        TableActiveModal
    },
    methods: {
        async getList() {
            this.tableLoading = true

            const { data } = await payoutRequests.list(this.listQuery)
            this.total = data.total
            this.tableData = data.data

            this.tableLoading = false
        },
        onTableActionModalSubmit() {
            this.getList()
        },
        checkRequest(data) {
            this.selectedData = data
            this.modalVisible = true
        },
        // 分页操作
        handleSizeChange(limit) {
            this.listQuery.limit = limit
            this.getList()
        },
        handleCurrentChange(page) {
            this.listQuery.page = page
            this.getList()
        },
        onFilteState() {
            this.getList()
        },
        handleSearch() {
            this.listQuery.page = 1
            this.getList()
        },
        // 导出Excel
        async exportExcel() {
            console.log('exportExcel')

            const { total } = this
            if (!total) return

            try {
                const { data: { data: reqData } } = await payoutRequests.list({ ...this.listQuery, page: 1, limit: total })

                var wb = XLSX.utils.book_new();

                var excelData = [
                    ['序号', '用户昵称', '兑换积分', '兑换金额', '提现币种', '收款类型', '提交时间', '状态'],
                    ...reqData.map((item, index) => [
                        index + 1,
                        item.user_info.name,
                        item.expend_integral,
                        item.withdrawal_price,
                        item.currency_type === 1 ? '人民币' : item.currency_type === 2 ? '日元' : '其它',
                        item.collection_type === 1 ? '银行卡' : item.collection_type === 2 ? '支付宝' : item.collection_type === 3 ? 'Plypal' : '其它',
                        item.created_at,
                        item.state === 0 ? '待审核' : item.state === 1 ? '通过' : item.state === 2 ? '失败' : item.state === 3 ? '已打款' : '无字段'
                    ])
                ];
                var ws = XLSX.utils.aoa_to_sheet(excelData);
                XLSX.utils.book_append_sheet(wb, ws, "提现列表");
                XLSX.writeFile(wb, "提现列表.xlsx");

                this.$notify.info({
                    title: '消息',
                    message: '请等待, 正在生成Excel表格文件...'
                });
            } catch {
                this.$notify.error({
                    title: '错误',
                    message: '获取数据错误!'
                });
            }
        }
    },
    created() {
        this.getList()
    }
}
</script>

<style lang="scss" scoped>
.table {
    margin-top: 10px;
}

.filter-container>.filter-item {
    margin-right: 10px;
}
</style>